import settings from "settings";

export const isChinese = () => settings.realm.languageCode === 'zh-cn';